"use client";

import React, { ReactElement, ReactNode } from "react";
import Link from "next/link";
import { cn } from "@/src/utils/functions";

interface ButtonLinkInterface extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    href: string;
    className?: string;
    title?: string;
    type?: "submit" | "button";
    scheme?: "primary" | "secondary" | "dark";
    children: ReactNode;
}

export default function ButtonLink(props: ButtonLinkInterface) {
    const { type, className, href, title, scheme, children } = props;
    const schemes = {
        primary: `bg-sky-600 [&.transparent]:bg-transparent text-white [&.transparent]:text-sky-600 hover:bg-sky-500 [&.transparent]:hover:text-sky-500 
                    disabled:hover:bg-sky-600 [&.transparent]:hover:bg-transparent focus:bg-sky-500 [&.transparent]:focus:bg-transparent active:bg-sky-700
                    [&.transparent]:active:bg-transparent`,
        secondary: "bg-amber-600 text-white hover:bg-amber-500 disabled:hover:bg-amber-600 focus:bg-amber-500 active:bg-amber-700",
        success: "bg-green-600 text-white hover:bg-green-500 disabled:hover:bg-green-600 focus:bg-green-500 active:bg-green-700",
        dark: `bg-gray-800 [&.transparent]:bg-transparent dark:bg-gray-800 text-white [&.transparent]:text-slate-500 dark:text-white hover:bg-gray-700 
                disabled:hover:bg-gray-800 dark:hover:bg-gray-700 focus:bg-gray-700 dark:focus:bg-white active:bg-gray-900 dark:active:bg-gray-300 focus:ring-indigo-500
                ring-offset-gray-800`,
        danger: "bg-red-600 text-white hover:bg-red-500 disabled:hover:bg-red-600 disabled:opacity-10 focus:bg-red-500 active:bg-red-700",
   }

    return (
        <Link 
            href={href} 
            title={title}
            // className={`${className} inline-flex justify-center items-center px-4 py-2 border border-transparent rounded-md 
            //         font-semibold text-[14px] focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:
            //         transition ease-in-out duration-150 ${schemes[scheme ?? "primary"]}`}
            className={
                cn(
                    `inline-flex justify-center items-center px-4 py-2 border border-transparent rounded-md font-semibold text-[14px] focus:outline-none focus:ring-2 
                    focus:ring-offset-2 dark:focus:ring-offset-gray-800 transition ease-in-out duration-150`, 
                    schemes[scheme ?? "primary"], 
                    className,
                )
            }
        >
            {children}
        </Link>
    )
}